import { render, staticRenderFns } from "./Link.vue?vue&type=template&id=6eefbb1a"
import script from "./Link.vue?vue&type=script&lang=js"
export * from "./Link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6eefbb1a')) {
      api.createRecord('6eefbb1a', component.options)
    } else {
      api.reload('6eefbb1a', component.options)
    }
    module.hot.accept("./Link.vue?vue&type=template&id=6eefbb1a", function () {
      api.rerender('6eefbb1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/sideBar/Link.vue"
export default component.exports